import 'core-js/stable';
// Import Component hooks before component definitions
import './component-hooks';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/vee-validate';
import './plugins/vue-gtag';
import './plugins/vue-toastification';
import { i18n } from './plugins/i18n';
import App from './App.vue';
import router from './router';
import store from '@/store';
import { setStore } from './apiClient';
import { setRouterStore } from './router';
import './registerServiceWorker';
import 'vuetify/dist/vuetify.min.css';
import './assets/brand.css';
import * as Sentry from '@sentry/vue'
import { handleSentryBeforeSend } from '@/utils/sentry';

Vue.config.productionTip = false;
setStore(store);
setRouterStore(store);

if (['production', 'staging', 'prod-k8s'].includes(process.env.VUE_APP_ENV)) {
  // TODO: historically the staging tag has been used for production, which is not ideal
  const environment = 'production';

  Sentry.init({
    Vue,
    dsn: 'https://eac05145381c45688e62d8f8b6bccbd6@o1280989.ingest.sentry.io/6485964',
    beforeSend: handleSentryBeforeSend,
    environment
  });
} else if (process.env.VUE_APP_ENV === 'qa') {
  Sentry.init({
    Vue,
    dsn: 'https://9f5515c3b748a27a71973a2a10c78680@o1280989.ingest.us.sentry.io/4510062221590528',
    beforeSend: handleSentryBeforeSend,
    environment: process.env.VUE_APP_ENV
  });
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
